import Reveal from "../../Reveal";
import SectionHeading from "../../SectionHeading";
import SpotlightCard from "../../SpotlightCard";
import GlobalHeadline from "../../../GlobalHeadline";
import { siteSections } from "../../../../content/siteSections";

/**
 * Engineering capabilities section.
 * Translation: Engineering capabilities section.
 *
 * @returns {JSX.Element} Services section.
 */
const Services = () => (
  <section id="services" className="section-block">
    <div className="section-shell">
      <SectionHeading
        eyebrow={siteSections.services.eyebrow}
        title={siteSections.services.title}
        centered
      />

      <div className="card-grid card-grid--three card-grid--flush">
        {siteSections.services.cards.map((card, index) => (
          <Reveal key={card.title} delay={index * 100}>
            <SpotlightCard className="glass-panel section-card section-card--service">
              <GlobalHeadline as="h3" className="mb-4">{card.title}</GlobalHeadline>
              <p>{card.description}</p>
              <ul className="service-bullets">
                {card.bullets.map((bullet) => (
                  <li key={bullet}>&gt; {bullet}</li>
                ))}
              </ul>
            </SpotlightCard>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
